import * as TypeGraphQL from "type-graphql";
export var AnalyticsSnapshotScalarFieldEnum;
(function (AnalyticsSnapshotScalarFieldEnum) {
    AnalyticsSnapshotScalarFieldEnum["id"] = "id";
    AnalyticsSnapshotScalarFieldEnum["symbol"] = "symbol";
    AnalyticsSnapshotScalarFieldEnum["timestamp"] = "timestamp";
    AnalyticsSnapshotScalarFieldEnum["dataType"] = "dataType";
    AnalyticsSnapshotScalarFieldEnum["metadata"] = "metadata";
    AnalyticsSnapshotScalarFieldEnum["createdAt"] = "createdAt";
    AnalyticsSnapshotScalarFieldEnum["updatedAt"] = "updatedAt";
})(AnalyticsSnapshotScalarFieldEnum || (AnalyticsSnapshotScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(AnalyticsSnapshotScalarFieldEnum, {
    name: "AnalyticsSnapshotScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=AnalyticsSnapshotScalarFieldEnum.js.map